import { AxnCompany, AxnRelyingParty, SimpleAxnWorkflow } from "@idw-types/data/reference-data/axn";
import { RpServiceType } from "@idw-types/data/reference-data/generic";
import { Dispatch } from "redux";
import { formatVerificationServiceConfigurations } from "@formatters/verification-services/verification-service-configuration-formatter";
import { FormattedVerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration/verification-service-configuration";
import { setVerificationServiceConfigurations, setVerificationServiceConfigurationsLoading } from "@redux/actions/verification-services-actions";
import { resources } from "@constants/hardcoded-strings";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getVerificationServiceConfigurationsRequest } from "@requests/service-configuration";

export const getVerificationServiceConfigurationsReduxRequest = (dispatch: Dispatch) => async (
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>,
    rpServiceTypes: Array<RpServiceType>,
    simpleAXNWorkflows: Array<SimpleAxnWorkflow>,
    simpleAXNAdminWorkflows: Array<SimpleAxnWorkflow>
): Promise<Array<FormattedVerificationServiceConfiguration>> => {
    dispatch(setVerificationServiceConfigurationsLoading(true));
    const { data, error } = await getVerificationServiceConfigurationsRequest();
    if (data?.rpserviceConfigs) {
        const formattedVerificationServiceConfigurations = formatVerificationServiceConfigurations(
            data.rpserviceConfigs,
            companies,
            relyingParties,
            rpServiceTypes,
            simpleAXNWorkflows,
            simpleAXNAdminWorkflows
        );
        dispatch(setVerificationServiceConfigurations(formattedVerificationServiceConfigurations));
        return formattedVerificationServiceConfigurations;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getVerificationServiceConfigurations.error.title,
                resources.requests.getVerificationServiceConfigurations.error.message
            );
        }
        dispatch(setVerificationServiceConfigurationsLoading(false));
    }

    return null;
};